import { IMPORT_DATA_REQUEST, IMPORT_DATA_SUCCESS, IMPORT_DATA_REQUEST_FAILURE } from "../types";

const initialState = {
    loading: false,
    error: null,
  };

  const importDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case IMPORT_DATA_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case IMPORT_DATA_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case IMPORT_DATA_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };

  export default importDataReducer;